import React, { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ConfigContext } from "../../Context/ConfigContext";
import { useTranslation } from 'react-i18next';
import {
    CartProcess,
    DeleteCartItem,
    GetCarts,
    QtyUpdate
} from "../../Helper/MyCart";
import { Spinner } from "../../Components/Shimmers";
import { AddToCartNotifier } from "../../Components/CartComponents";
import CartItem from "./CartItem";

function PlaceOrder() {

    const { apiB2BURL, apiURL, gdcURL, UpdateCartList, ChangeCartStatus, CartStatus, lang, setCartItemsQty, setStateGlobleCart } = useContext(ConfigContext);

    const [cartItems, setCartItems] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [points, setPoints] = useState(0);
    const [coupon, setCoupon] = useState(localStorage.getItem("coupon"));
    const [couponData, setCouponData] = useState([]);
    const [cartLoading, setCartLoading] = useState(true);
    const [couponsLoading, setCouponsLoading] = useState(true);
    const [shimmerCarItem, setShimmerCarItem] = useState('cart-item-');
    const [partNumber, setPartNumber] = useState('');
    const [quantity, setQuantity] = useState('');
    const [orderCartItems, setOrderCartItems] = useState([]);

    const AddByPartNumber = async () => {
        try {

            const response = await axios.get(`${apiB2BURL}/Customer/Parts/GetPartInfoByNumber`, {
                params: {
                    currency: localStorage.getItem('currency') ?? 'aed',
                    lang: lang,
                    business_id: localStorage.getItem('business_id') || 0,
                    part_number: partNumber,
                    quantity: quantity,
                }
            });
            const data = response.data.data;
            if (data) {
                var row = data[0];
                row.requested_quantity = quantity;
                setCartItems((prevItems) => [...prevItems, row]);
            } else {
                console.error(data.message);
            }

        } catch (err) {
            // console.log("LoadCart err", err);
        }
    };


    useEffect(() => {
        setCartLoading(true);
        setCouponsLoading(true);
        fetchCartDataFromLocalStorage();
        GetCoupons();
    }, []);

    const fetchCartDataFromLocalStorage = async () => {


        // if (coupon) {
        //   localStorage.getItem("coupon");
        // }
        try {
            var carts = GetCarts();
            if (carts && Array.isArray(carts) && carts.length > 0) {
                const response = await axios.post(`${apiB2BURL}/Customer/Orders/GetCart`, {
                    currency: localStorage.getItem('currency') ?? 'aed',
                    lang: lang,
                    business_id: localStorage.getItem('business_id') || 0,
                    carts: carts, // no need to stringify
                    coupon: coupon,
                });

                const data = response.data.data;
                if (data) {
                    setCartLoading(false);
                    setCouponsLoading(false);
                    setCartItems(data);
                    setPoints(response.data.data.points);
                    setShimmerCarItem('cart-item-');
                } else {
                    console.error(data.message);
                }
            } else {
                setCartLoading(false);
                setCouponsLoading(false);
                setShimmerCarItem('cart-item-');
                setCartItems([]);
            }
        } catch (err) {
            // console.log("LoadCart err", err);
        }
    };

    const GetCoupons = async () => {

        try {
            const response = await axios.get(`${apiURL}/Home/GetCoupons?lang=en`);
            const data = response.data.data;
            if (data) {
                setCouponData(data);
            } else {
                console.log("No Coupons Found");
            }
        } catch (err) {
            console.log("err Something Went Wrong", err);
        }
    };

    const handleCouponCodeChange = (e) => {

        setCoupon(e.target.value);
    };





    const RemoveCoupon = () => {
        localStorage.removeItem("coupon");
        setCoupon("");
        fetchCartDataFromLocalStorage();
    };

    const ApplyCoupon = async (couponCode, e) => {
        e.preventDefault();
        localStorage.setItem("coupon", couponCode);

        setCoupon(couponCode);
        fetchCartDataFromLocalStorage();
    };

    const { t } = useTranslation();
    const dir = localStorage.getItem('dir');

    return (
        <main className="main" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
            <ToastContainer
                position="bottom-center"
                autoClose={1000}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                theme="dark"
                closeButton={false}
                hideProgressBar
            />
            <div className="container mt-4">
                <h5 className={`mb-3 ${dir === 'rtl' ? 'text-right' : 'text-left'}`} >{t("Search Part")}</h5>
                <div className="row" style={{ backgroundColor: '#FFF' }}>

                    <div className={`col-lg-8 ${dir === 'rtl' ? 'text-right' : 'text-left'} mb-1`} >
                        <input type="text" className="form-control form-control-sm" style={{ height: '43px', borderRadius: '50px' }} placeholder={`Search by part number`} value={partNumber} onChange={(e) => setPartNumber(e.target.value)} required />
                    </div>
                    <div className={`col-lg-2 ${dir === 'rtl' ? 'text-right' : 'text-left'} mb-1`} >
                        <input type="text" className="form-control form-control-sm" style={{ height: '43px', borderRadius: '50px' }} placeholder={`Quantity`} value={quantity} onChange={(e) => setQuantity(e.target.value)} required />
                    </div>
                    <div className={`col-lg-2 ${dir === 'rtl' ? 'text-right' : 'text-left'} mb-2`} >
                        <button className="btn btn-sm btn-primary" style={{ height: '43px', borderRadius: '50px' }} onClick={AddByPartNumber}>{t("Add to order inquiry")}</button>
                    </div>
                </div>
                <hr style={{ margin: 0 }} />

                <div className="card">
                    <div className="card-body">
                        <h5 className={`mb-0 ${dir === 'rtl' ? 'text-right' : 'text-left'}`} >{t("Your Basket")}</h5>
                        <hr style={{ margin: 0 }} />
                        <table className="table table-bordered mt-2" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
                            <thead>
                                <tr>
                                    <th>{t("Part Number")}<br /><small>{t("Part No., Name & Desc")}</small></th>

                                    <th>{t("Brand")}</th>
                                    <th>{t("Quantity")}</th>
                                    <th><br /><small>{t("NSP (Incl. VAT)")}</small></th>
                                    <th><br /><small>{t("Amt")}</small></th>
                                    <th><br /><small>{t("NSP (Excl. VAT)")}</small></th>

                                    <th>{t("Available")}</th>
                                    <th>{t("Specifications")}<br /><small>{t("L x W x H(mm) | W(gm)")}</small></th>

                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.ART_ARTICLE_NR}<br /><small>{item.STR_NODE_NAME_EN}</small></td>
                                        <td>{item.ART_SUP_BRAND}</td>
                                        <td > <div style={{ display: 'flex', justifyContent: 'space-between' }}><small>{item.requested_quantity}</small></div></td>
                                        <td><small>{item.stock_bb_price}</small></td>
                                        <td><small>{item.stock_bb_price}</small></td>
                                        <td><small>{item.total_excl_vat}</small></td>

                                        <td>{item.stock_available_qty}</td>
                                        <td><small>{item.ARTICLE_CRITERIA.map((dim, i) => (
                                            <div key={i}>{dim.criteria_en}:{dim.value_en} | </div>
                                        ))}</small></td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* End .row */}
            </div>
            {/* End .container */}
            <div className="mb-6" />
            {/* margin */}
        </main>
    );
}

export default PlaceOrder;
